import { render, staticRenderFns } from "./ReportRatingComponent.vue?vue&type=template&id=3b55660c&scoped=true&"
import script from "./ReportRatingComponent.vue?vue&type=script&lang=js&"
export * from "./ReportRatingComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReportRatingComponent.vue?vue&type=style&index=0&id=3b55660c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b55660c",
  null
  
)

export default component.exports